<div class="flex flex-col flex-auto col-span-2 overflow-hidden">
  <mat-icon svgIcon="heroicons_outline:x-mark" class="ml-100" style="cursor: pointer;" (click)="sauvegarder()"></mat-icon>
  <mat-form-field
    class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded min-w-0 p-6 mt-1"
  >
    <mat-icon
      class="icon-size-5"
      matPrefix
      [svgIcon]="'heroicons_outline:magnifying-glass'"
    ></mat-icon>

    <input
      matInput
      (keyup)="appliquerFiltre($event)"
      [placeholder]="'Filtrer actifs'"
    />
  </mat-form-field>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="Nom Actif">
      <th mat-header-cell *matHeaderCellDef>Nom Actif</th>
      <td
        mat-cell
        *matCellDef="let element"
        class="font-semibold hover:underline cursor-pointer"
      >
        {{ element.referentiel.stockName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td
          mat-cell
          *matCellDef="let element"
          class="action-link"
        >
          <button
            (click)="supprimerTitre(element.referentiel.stockName)"
            mat-button
            color='primary'
            *ngIf="showDeleteButton(element.referentiel.stockName)"
          >
            <mat-icon
              class="icon-size-5"
              [svgIcon]="'heroicons_solid:check-circle'"
            ></mat-icon>
          </button>
          <button
            (click)="ajouterTitre(element.referentiel.stockName)"
            mat-button
            [color]="'primary'"
            *ngIf="!(watchlist?.includes(element.referentiel.stockName))"
          >
            <mat-icon
              class="icon-size-5"
              [svgIcon]="'heroicons_solid:plus-circle'"
            ></mat-icon>
          </button>
        </td>
      </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    #paginator
    [length]="dataSource.filteredData.length"
    [pageIndex]="0"
    [pageSize]="5"
    [pageSizeOptions]="[5, 10]"
  >
  </mat-paginator>
  <button (click)="sauvegarder()" class="ml-4" mat-flat-button type="button" [color]="'primary'">
    <span class="ml-2">Enregistrer</span>
  </button>
</div>
